import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  height: 3rem;
  align-items: center;

  p {
    margin: 0 0.5rem;
    justify-content: center;
    display: flex;
    background-color: ${({ theme }) => theme.colors.background_white} !important;
    color: ${({ theme }) => theme.colors.secondary} !important;
    font-size: 1.5rem !important;
    font-weight: 600 !important;
  }

  div {
    width: 45%;
    border: solid 1px ${({ theme }) => theme.colors.primary};
  }
`;
